import { Modal } from "antd";
import { StyledTable } from "atoms/Table";
import dayjs from "dayjs";
import React from "react";
import { useSelector } from "react-redux";
import { getUserInfo, getUserList, getCountryTimezone } from "redux/selectors";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { KeyboardArrowDown } from "@mui/icons-material";
dayjs.extend(timezone);
dayjs.extend(utc);

const AppraisalHistory = ({
  isModalOpen,
  setIsModalOpen,
  appraiseeid,
  data,
  title,
}) => {
  const userList = useSelector(getUserList) || [];
  const CountryTimezone = useSelector(getCountryTimezone);
  const userInfo = useSelector(getUserInfo) || {};

  const finduser = userList.find((item) => item?.userid === userInfo?.userid);

  const priorityMap = [
    {
      field: "reviewedon",
      status: "Closed",
      userField: "reviewedby",
      contractstatus: "reviewed",
    },
    {
      field: "attendedon",
      status: "Attended",
      userField: "attendedby",
      contractstatus: "attended",
    },
    {
      field: "accepteddeclinedon",
      status: "Accepted",
      userField: "accepteddeclinedby",
      contractstatus: "accepted",
    },
    {
      field: "updatedon",
      status: "Resent",
      userField: "updatedby",
      contractstatus: "resend",
    },
    {
      field: "accepteddeclinedon",
      status: "Declined",
      userField: "accepteddeclinedby",
      contractstatus: "declined",
      declinedreason: "declinedreason",
    },
    {
      field: "updatedon",
      status: "Updated",
      userField: "updatedby",
      contractstatus: "updated",
    },
    {
      field: "createdon",
      status: "Created",
      userField: "createdby",
      contractstatus: "created",
    },
  ];

 const statusLogs = [];
  let hasSeenReviewed = false;

  // Process oldest → newest to correctly flag first "reviewed" as Closed
  for (const record of [...data]) {
    for (const entry of priorityMap) {
      const date = record[entry.field];
      if (date && record.contractstatus === entry.contractstatus) {

        let status = entry.status;

        if (entry.contractstatus === "reviewed") {
          if (!hasSeenReviewed) {
            status = "Closed";       // first ever reviewed = Closed
            hasSeenReviewed = true;
          } else {
            status = "Updated";      // all subsequent reviewed = Updated
          }
        }

        statusLogs.push({
          key: `${entry.status}-${record[entry.userField]}-${date}`,
          status,
          date,
          declinedreason:
            entry.contractstatus === "declined" ? record?.declinedreason : "",
          userid:
            record[entry.userField] === userInfo?.userid
              ? "You"
              : userList.find(
                  (item) => item?.userid === record[entry.userField]
                )?.fullname || "-",
        });
        break;
      }
    }
  }

  // Reverse at the END so newest appears at top in the table
  statusLogs.reverse();
  
  const columns = [
    {
      title: "Action by",
      dataIndex: "status",
      key: "status",
      render: (_, record) => (
        <span style={{ color: "#4B5563", fontWeight: 500 }}>
          {record.status} by{" "}
          <span style={{ fontWeight: 600 }}>{record.userid}</span>
        </span>
      ),
    },
    {
      title: "Date & Time",
      dataIndex: "date",
      key: "date",
      render: (date) => (
        <span style={{ color: "#4B5563" }}>
          {dayjs(date).utc().tz("Africa/Nairobi").format("D MMM YYYY, hh:mm A")}
        </span>
      ),
    },
  ];

  return (
    <Modal
      title={title}
      open={isModalOpen}
      onCancel={() => setIsModalOpen(false)}
      footer={null}
      width={700}
    >
      <StyledTable
        columns={columns}
        dataSource={statusLogs}
        pagination={false}
        showHeader={true}
        bordered={false}
        rowClassName={(_, index) => (index % 2 === 0 ? "even-row" : "odd-row")}
        expandable={{
          expandedRowRender: (record) => (
            <div
              style={{
                backgroundColor: "#F9FAFB",
                border: "1px solid #E5E7EB",
                borderRadius: 8,
                padding: "12px",
                color: "#111827",
                fontSize: "15px",
                whiteSpace: "wrap",
                wordBreak: "break-word",
              }}
            >
              {record.declinedreason}
            </div>
          ),
          rowExpandable: (record) => !!record.declinedreason,
          expandIcon: ({ expanded, onExpand, record }) =>
            record?.declinedreason ? (
              <span
                style={{
                  color: "#1890ff",
                  textDecoration: "underline",
                  cursor: "pointer",
                  fontWeight: 500,
                }}
                onClick={(e) => onExpand(record, e)}
              >
                {expanded ? "Reason for Decline" : "Reason for Decline"}{" "}
                {expanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDown />}
              </span>
            ) : null,
          expandIconColumnIndex: 2,
        }}
      />
    </Modal>
  );
};

export default AppraisalHistory;
